<template>
  <b-table :items="items" responsive :fields="fields" :busy="loading">
    <template #head(id)="row">
      {{ row.label }}
      <a href="#" @click.prevent="$router.push({ name: 'procesos-listado-orden-de-pedido' })">Ir</a>
    </template>
    <template #cell(actions)="row">
      <a
        href="#"
        v-if="$store.state.user.scope.includes('puede-cambiar-prioridad-op')"
        @click.prevent="$bvModal.show(`op-info-modal-${row.item.id}`)"
        ><i class="fa fa-lg fa-info mr-2"></i
      ></a>
      <b-modal :id="`op-info-modal-${row.item.id}`">
        <div v-if="row.item.config.defects">
          <h5>Filtros aplicados:</h5>
          <ul>
            <li v-for="filter in row.item.config.defects" :key="filter.id">
              {{ filter }}
            </li>
          </ul>
        </div>
        <div v-if="row.item.config.sidePallets">
          <h5>Pallets gestionados</h5>
          <strong>Motivo:</strong> {{ row.item.config.sidePallets.motivo }}
          <ul>
            <li v-for="pallet in row.item.config.sidePallets.pallets" :key="pallet.id">
              {{ pallet.pallet_number }}
            </li>
          </ul>
        </div>
      </b-modal>
      <a
        href="#"
        v-if="$store.state.user.scope.includes('puede-cambiar-prioridad-op')"
        @click.prevent="togglePriority(row.item.id)"
        ><i class="fa fa-lg fa-arrow-up"></i
      ></a>
      <assign-shipment :id="row.item.id" @refresh="handleShow(false)"></assign-shipment>
      <CreatePurchaseOrder :id="row.item.id" :op-id="row.item.id" :planData="row.item" @refresh="handleShow(false)" />
      <a
        href="#"
        v-if="$store.state.user.scope.includes('puede-cambiar-prioridad-op')"
        @click.prevent="deleteOp(row.item.id)"
        ><i class="fa fa-lg fa-trash text-danger ml-1"></i
      ></a>
    </template>
    <template #cell(status)="row">
      <b-badge :variant="getStatusColor(row.item.status)">{{ row.item.status }}</b-badge>
    </template>
    <template #cell(priority)="row">
      <i class="fa fa-lg fa-arrow-up text-danger" v-if="row.item.priority"></i>
      <i class="fa fa-lg fa-arrow-down text-secondary" v-else></i>
    </template>
    <template #table-busy>
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
    </template>
  </b-table>
</template>

<script>
import CreatePurchaseOrder from "./CreatePurchaseOrder.vue";
import AssignShipment from "./AssignShipment.vue";

export default {
  name: "OpList",
  components: {
    CreatePurchaseOrder,
    AssignShipment
  },
  props: {
    items: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: [
        { key: "id", label: "OP" },
        "delivery_date",
        "priority",
        { key: "shipment__boarding_number", label: "Embarque" },
        "status",
        "progress",
        "kilograms",
        "completed_kilograms",
        { key: "actions", label: "" }
      ]
    };
  },
  methods: {
    handleShow(refresh) {
      this.$emit("refresh", refresh);
    },
    getStatusColor(status) {
      switch (status) {
        case "vigente":
          return "primary";
        case "terminado":
          return "success";
        case "cancelado":
          return "danger";
        default:
          return "secondary";
      }
    },
    async deleteOp(opId) {
      this.$swal({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta acción",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete.value) {
          try {
            await this.$axios.delete("/api/v1/purchase_order/" + opId + "/");
            this.$swal("¡Eliminado!", "La orden de pedido ha sido eliminada", "success");
            this.handleShow(true);
          } catch (error) {
            console.log(error);
            this.$swal("¡Error!", "No se pudo eliminar la orden de pedido", "error");
          } finally {
            this.$emit("refresh");
          }
        }
      });
    },
    async togglePriority(id) {
      try {
        await this.$axios.put("/api/v1/purchase_order/" + id + "/toggle_priority/");
      } catch (error) {
        console.log(error);
      } finally {
        this.$emit("refresh");
      }
    }
  }
};
</script>

<style></style>
